import { Inbox } from "lucide-react";

export function EmptyState({ title = "Nothing here yet", description, icon: Icon = Inbox, testId }) {
  return (
    <div data-testid={testId} className="flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-jigsaw-border bg-white py-14 text-center">
      <Icon className="h-8 w-8 text-jigsaw-muted" />
      <p className="text-sm font-medium text-jigsaw-navy">{title}</p>
      {description && <p className="max-w-sm text-sm text-jigsaw-muted">{description}</p>}
    </div>
  );
}

export function LoadingState({ testId }) {
  return (
    <div data-testid={testId} className="flex items-center justify-center py-20">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-jigsaw-border border-t-jigsaw-orange" />
    </div>
  );
}

export function ErrorState({ message = "Something went wrong. Please try again.", testId }) {
  return (
    <div data-testid={testId} className="flex flex-col items-center justify-center gap-2 rounded-lg border border-jigsaw-danger/30 bg-jigsaw-dangerBg py-14 text-center">
      <p className="text-sm font-medium text-jigsaw-danger">{message}</p>
    </div>
  );
}
